__turbopack_context__.v({
  "label": "PromoBadgeLabel-module-sass-module__S_3MKW__label",
  "label-text": "PromoBadgeLabel-module-sass-module__S_3MKW__label-text",
  "main": "PromoBadgeLabel-module-sass-module__S_3MKW__main",
  "main-text": "PromoBadgeLabel-module-sass-module__S_3MKW__main-text",
  "wrapper": "PromoBadgeLabel-module-sass-module__S_3MKW__wrapper",
});
